import { render, staticRenderFns } from "./SelectDateFilter.vue?vue&type=template&id=b87c20e8&scoped=true&"
import script from "./SelectDateFilter.vue?vue&type=script&lang=js&"
export * from "./SelectDateFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87c20e8",
  null
  
)

export default component.exports